import React, { useMemo } from "react";
import { Form } from "react-final-form";
import classNames from "classnames";
import ResultDimensionDialog from "../../../ResultDimensionDialog";
import ScrollBar from "components/ScrollBar";
import { SCROLL_BAR_MAX_HEIGHT } from "components/Dialog";
import Input from "rs-components/Input";
import CheckBoxInput from "rs-components/Input/components/CheckBoxInput";
import HiddenInput from "rs-components/Input/components/HiddenInput";
import TextTruncate from "components/TextTruncate";
import { isFormValid } from "shared/validators";
import { ALTERNATIVE_FLOW_SELECTION_INSTRUCTION } from "shared/labels";
import { MIN_FLOWS_QUANTITY } from "store/rs-workspace/utils/common.utils";
import * as styles from "./styles.module.scss";
export var FormFields;
(function (FormFields) {
    FormFields["flow"] = "flow";
    FormFields["flowIndexes"] = "flowIndexes";
})(FormFields || (FormFields = {}));
const onCheckFlow = (form, checked, index) => {
    const flowIndexes = form.getFieldState(FormFields.flowIndexes)?.value;
    form.batch(() => {
        if (checked) {
            form.change(FormFields.flowIndexes, [...(flowIndexes ?? []), index]);
        }
        else {
            const newFlowIndexes = flowIndexes?.filter((idx) => idx !== index) ?? [];
            form.change(FormFields.flowIndexes, newFlowIndexes.length > 0 ? newFlowIndexes : undefined);
        }
        form.blur(FormFields.flowIndexes);
    });
};
const RangeDialog = ({ flows, title, onSubmit, onClose }) => {
    const initialValues = useMemo(() => ({ [FormFields.flow]: flows?.flowIndexesSelection, [FormFields.flowIndexes]: flows?.flowIndexes }), [flows?.flowIndexes, flows?.flowIndexesSelection]);
    return (React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, validateOnBlur: true }, ({ handleSubmit, form, initialValues, ...renderProps }) => (React.createElement(ResultDimensionDialog, { title: title, onClose: onClose, onClosed: () => form.reset(initialValues), onSubmit: handleSubmit, submitDisabled: !isFormValid(renderProps), placement: "bottom-start", classes: { content: styles.dialog } },
        React.createElement(ScrollBar, { autoHeight: true, autoHeightMax: SCROLL_BAR_MAX_HEIGHT },
            React.createElement("div", { className: styles.root },
                React.createElement("div", { className: classNames(styles.instruction, {
                        [styles.accented]: (form.getFieldState(FormFields.flowIndexes)?.value?.length || 0) < MIN_FLOWS_QUANTITY,
                    }) }, ALTERNATIVE_FLOW_SELECTION_INSTRUCTION),
                React.createElement(Input, { component: HiddenInput, name: FormFields.flowIndexes, suppressErrors: true }),
                React.createElement("div", { className: styles.flows }, flows?.flowsList.map((flow, index) => (React.createElement("div", { key: flow, className: styles["flows-row"] },
                    React.createElement(Input, { component: CheckBoxInput, name: `flow[${index}]`, onChange: (value) => onCheckFlow(form, value, index) }),
                    React.createElement(TextTruncate, { className: styles.label, text: flow })))))))))));
};
export default RangeDialog;
